import { UseMutationResult, useMutation } from '@tanstack/react-query';
import qrCodeApi from './qr-code-api';
import { AxiosResponse } from 'axios';

export type GenerateQrCodeInSvg200Response = AxiosResponse<string>;
interface GenerateQrCodeVariables {
  url: string;
  onSuccess: (response: GenerateQrCodeInSvg200Response) => void;
}

const useGenerateQrCodeSvg = (): UseMutationResult<
  GenerateQrCodeInSvg200Response,
  unknown,
  GenerateQrCodeVariables,
  unknown
> => {
  return useMutation({
    mutationFn: (variables: GenerateQrCodeVariables) =>
      qrCodeApi.generateQrCodeInSvg(variables.url, {
        responseType: 'arraybuffer',
      }),
    onSuccess: (response, variables) => {
      variables.onSuccess(response);
    },
  });
};

export default useGenerateQrCodeSvg;
